<template>
  <div>
    <b-container fluid class="my-4">
      <b-button-toolbar>
        <b-input-group size="sm" prepend="Search:" class="mr-2">
          <b-form-input :value="q" @change="setSearch" type="search" />
          <!-- <template #append>
            <b-button variant="light" size="sm">
              <b-icon-search />
            </b-button>
          </template> -->
        </b-input-group>
        <b-button-group class="mr-2">
          <b-dropdown
            v-for="group of filterGroups"
            :key="group.text"
            :text="
              group.text +
              (activeFilter.group == group.text ? `: ${activeFilter.text}` : '')
            "
            :variant="activeFilter.group == group.text ? 'primary' : 'light'"
            size="sm"
          >
            <b-dropdown-item-button
              v-for="filter in group.filters"
              :key="filter.key"
              :text="filter.text"
              @click="setFilter(filter.value)"
              :active="type == filter.value"
              :disabled="filter.disabled"
              class="text-small"
            >
              {{ filter.text }}
            </b-dropdown-item-button>
          </b-dropdown>
        </b-button-group>
        <b-dropdown lazy text="Show/Hide columns" variant="light" size="sm">
          <b-dropdown-group v-for="group of fieldGroups" :key="group.key">
            <template #header>
              <!-- <b-link @click="toggleFields(group)"> -->
              {{ group.label }}
              <!-- </b-link> -->
            </template>
            <b-dropdown-form class="text-small" :style="{ width: '220px' }">
              <b-form-checkbox
                @input="setField(field)"
                :checked="field.active"
                v-for="field in group.fields"
                :key="field.key"
              >
                {{ field.label }}
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown-group>
          <b-dropdown-divider />
          <b-dropdown-item-button
            @click="setDefaultFields(true)"
            class="text-small"
          >
            Reset
          </b-dropdown-item-button>
        </b-dropdown>
        <b-button
          v-if="filterVars"
          variant="light"
          size="sm"
          @click="$refs.csv.download()"
          class="ml-auto"
        >
          <Csv
            :site="site"
            name="pages"
            :where="filterVars.where"
            :order="filterVars.order"
            text="Export CSV"
            ref="csv"
          />
        </b-button>
      </b-button-toolbar>
    </b-container>
    <b-table
      id="pages-table"
      :fields="hasDetailPane ? ['title'] : activeFields.filter((e) => e.active)"
      :items="items"
      primary-key="id"
      :busy="loading"
      :thead-class="hasDetailPane ? 'd-none' : ''"
      :sort-by="value.sort"
      @update:sortBy="update('sort', $event)"
      :sort-desc.sync="value.desc"
      @update:sortDesc="update('desc', $event)"
      :no-local-sorting="true"
      :class="className"
      ref="pagesTable"
      @row-clicked="onRowClicked($event)"
      @row-hovered="onRowHovered($event)"
      :tbody-tr-class="rowClass"
      data-hj-ignore-attributes
    >
      <template v-slot:table-busy>
        <b-skeleton-table
          :rows="limit"
          :columns="
            hasDetailPane ? 1 : activeFields.filter((e) => e.active).length || 5
          "
          :hide-header="true"
        ></b-skeleton-table>
      </template>
      <template v-slot:cell(title_score)="row">
        <div class="text-center">
          <Score :value="row.value" />
        </div>
      </template>
      <template v-slot:cell(link_score)="row">
        <div class="text-center">
          <Score :value="row.value" />
        </div>
      </template>
      <template v-slot:cell(perf_score)="row">
        <div class="text-center" v-if="row.value != 100">
          <Score :value="row.value" />
        </div>
      </template>
      <template v-slot:cell(title)="row">
        <div v-if="row.item.isObscured" class="obscured">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit
        </div>
        <template v-else>
          <span class="text-primary page_title" translate="no">{{
            row.item.custom_title ||
            row.item.title ||
            (row.item.crawled_at ? '(No Title)' : '(Not Crawled)')
          }}</span>
          <!-- <span class="text-small ml-1"><PageTags :page="row.item" /></span> -->
          <span
            class="text-small text-muted hover-show ml-2"
            v-if="!hasDetailPane"
            ><b-icon-pencil size="sm" />&nbsp;Edit</span
          >
        </template>
      </template>
      <template v-slot:cell(serp_title)="row">
        <div v-if="row.item.isObscured" class="obscured">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit
        </div>
        <template v-else-if="row.item.serp_title">
          <b-icon-exclamation-triangle-fill
            v-if="row.item.is_rewritten"
            class="mr-2 text-warning"
          />
          <b-icon-check-circle-fill v-else class="mr-2 text-muted" />
          <Diff :old="liveTitle(row.item)" :new="row.value" :one-line="true" />
        </template>
      </template>
      <template v-slot:cell(url)="row">
        <div class="text-small text-nowrap">
          <template v-if="row.item.isObscured">
            <span class="obscured">https://example.com/</span>
            <b-icon-lock-fill
              class="ml-2 text-secondary"
              v-b-tooltip="obscuredTooltip"
            />
          </template>
          <a
            v-else
            :href="row.item.url"
            :title="row.item.url"
            target="_blank"
            class="text-break text-muted"
          >
            <span class="page_url mr-1">{{ decodeURI(row.item.url) | truncate(70) }}</span>
            <b-icon-box-arrow-up-right class="mr-2" />
          </a>
          <span
            class="text-small text-muted hover-show ml-2"
            v-if="!hasTitleField"
            ><b-icon-pencil size="sm" />&nbsp;Edit</span
          >
        </div>
      </template>
      <template v-slot:cell(clicks)="row">
        <div class="text-right" v-if="row.item.clicks">
          {{ row.item.clicks | formatNumber }}
        </div>
      </template>
      <template v-slot:cell(site_clicks_delta)="row">
        <div class="text-right">
          <template v-if="row.item.site_page_clicks_all !== null">
            {{
              (row.item.site_page_clicks_all.delta * 100) | formatNumber(true)
            }}%
            <b-icon-record-fill
              :variant="
                row.item.site_page_clicks_all.delta < 0 ? 'danger' : 'success'
              "
            />
          </template>
          <b-icon-clock
            v-else-if="row.item.improved_at"
            v-b-tooltip="`Traffic data has not been collected yet`"
          />
        </div>
      </template>
      <template #head(potential)>
        Potential<sup
          ><b-icon-info-circle
            v-b-tooltip.hover="
              `Click Potential is modeled on the value of lower-ranking keywords moving up in position, along with page optimization scores. All values are 28 days.`
            "
        /></sup>
      </template>
      <template v-slot:cell(potential)="row">
        <div class="text-right" v-if="row.value">
          <span class="potential"
            ><span class="⨦">⨦</span
            >{{ row.value | toMonthly | formatNumber }}</span
          >
        </div>
      </template>
      <template v-slot:cell(status)="row">
        {{
          (row.value || row.item.status_inferred).replace(
            'completed',
            'monitoring'
          ) | titleCase
        }}
      </template>
      <template v-slot:cell(improved_at)="row">
        <div v-if="row.value">
          {{ row.value | formatDate }}
        </div>
      </template>
      <template v-slot:cell(created_at)="row">
        <div v-if="row.value">
          {{ row.value | formatDate }}
        </div>
      </template>
      <template v-slot:cell(status_code)="row">
        <div class="text-right">
          <b-badge
            v-if="row.value"
            :variant="
              row.value == 200
                ? 'light'
                : row.value < 400
                ? 'warning'
                : 'danger'
            "
            >{{ row.value }}</b-badge
          >
        </div>
      </template>
      <template v-slot:cell(inbound_link_count)="row">
        <div class="text-right">
          {{ row.value | formatNumber }}
        </div>
      </template>
      <template v-slot:cell(outbound_link_count)="row">
        <div class="text-right">
          {{ row.value | formatNumber }}
        </div>
      </template>
      <template v-slot:cell(inbound_anchor_count)="row">
        <div class="text-right" v-if="row.value">
          {{ row.value | formatNumber }}
        </div>
      </template>
      <template v-slot:cell(nofollow_links)="row">
        <div class="text-right" v-if="row.item.nofollow_links_aggregate">
          {{ row.item.nofollow_links_aggregate.aggregate.count | formatNumber }}
        </div>
      </template>
      <template v-slot:cell(broken_links)="row">
        <div class="text-right" v-if="row.item.broken_links_aggregate">
          {{ row.item.broken_links_aggregate.aggregate.count | formatNumber }}
        </div>
      </template>
      <template v-slot:cell(response_time)="row">
        <div class="text-right" v-if="row.value && row.value.response_time > 0">
          <b-icon-record-fill
            v-if="row.value.response_time > 2000"
            variant="danger"
          />
          <b-icon-record-fill
            v-else-if="row.value.response_time > 600"
            variant="warning"
          />
          {{ row.value.response_time | formatNumber }} ms
        </div>
      </template>
      <template v-slot:cell(asset_length)="row">
        <div class="text-right" v-if="row.item.asset_issues">
          <b-icon-record-fill
            v-if="row.item.asset_issues.content_length > 2e6"
            variant="danger"
          />
          <b-icon-record-fill v-else-if="row.item.asset_issues.content_length > 1e6" variant="warning" />
          {{ (row.item.asset_issues.content_length / 1e6).toFixed(1) }} mb
        </div>
      </template>
    </b-table>
    <div class="table-shortcuts" v-if="hasDetailPane">
      <b-badge class="shortcut ml-3 mr-1">↑</b-badge
      ><b-badge class="shortcut">↓</b-badge>
    </div>
    <div v-if="total > pages.length">
      <b-pagination
        :value="value.page"
        @input="update('page', $event)"
        :total-rows="total"
        :per-page="limit"
        first-number
        last-number
        align="center"
      ></b-pagination>
    </div>
  </div>
</template>
<style>
.obscured {
  color: transparent;
  text-shadow: 0 0 0.4em rgba(0, 0, 0, 0.5);
  cursor: default;
}
a[target='_blank'] {
  cursor: alias;
}

.row-obscured {
  cursor: default;
}
th {
  white-space: nowrap;
}
</style>
<script>
import PageTags from '@/components/PageTags'
import Score from '@/components/Score'
import Diff from '@/components/Diff'
import Csv from '@/components/Csv'
import _ from 'lodash'

export default {
  name: 'PagesTable',
  components: { PageTags, Score, Diff, Csv },
  props: [
    'value',
    'type',
    'q',
    'isProcessing',
    'isFreetrial',
    'limit',
    'pages',
    'total',
    'hasDetailPane',
    'loading',
    'sortable',
    'className',
    'filterVars',
    'site',
    'siteDelta'
  ],

  data: () => {
    return {
      hoveredPageId: null,
      activeFields: []
    }
  },
  mounted() {
    const stored = this.fetchFields()
    const fields = this.fields
    stored
      .filter((f) => f)
      .forEach((f) => {
        const field = fields.find((e) => e.key == f.key)
        if (field && f.active != field.active) {
          field.active = f.active
        }
      })
    this.activeFields = fields
    this.setDefaultFields()
  },
  computed: {
    fields() {
      const fields = [
        {
          key: 'title_score',
          label: 'Title Score',
          thClass: 'text-center',
          sortable: this.sortable,
          active: true,
          group: 'title'
        },
        {
          key: 'link_score',
          label: 'Link Score',
          thClass: 'text-center',
          sortable: this.sortable,
          active: true,
          group: 'links'
        },
        {
          key: 'perf_score',
          label: 'Perf Score',
          thClass: 'text-center',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'title',
          label: 'Title',
          sortable: this.sortable,
          active: true,
          group: 'title'
        },
        {
          key: 'serp_title',
          label: 'SERP Title',
          sortable: this.sortable,
          active: false,
          group: 'title'
        },
        {
          key: 'url',
          label: 'URL',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'clicks',
          label: 'Clicks',
          thClass: 'text-right',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'status',
          label: 'Optimization Status',
          sortable: this.sortable,
          active: false,
          group: 'page'
        },
        {
          key: 'improved_at',
          label: 'Date Improved',
          sortable: this.sortable,
          active: false,
          group: 'page'
        },
        {
          key: 'created_at',
          label: 'Date First Crawled',
          sortable: this.sortable,
          active: false,
          group: 'page'
        },
        {
          key: 'site_clicks_delta',
          label: `Clicks vs. Site Average`,
          thClass: 'text-right',
          sortable: true,
          active: true,
          group: 'page'
        },
        {
          key: 'potential',
          label: 'Potential',
          thClass: 'text-right',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'status_code',
          label: 'Status Code',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'response_time',
          label: 'Response Time',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'asset_length',
          label: 'Asset Weight',
          sortable: this.sortable,
          active: true,
          group: 'page'
        },
        {
          key: 'language',
          label: 'Language',
          sortable: this.sortable,
          active: false,
          group: 'page'
        },
        {
          key: 'inbound_link_count',
          label: 'Internal Inlinks',
          thClass: 'text-right',
          sortable: this.sortable,
          active: true,
          group: 'links'
        },
        {
          key: 'outbound_link_count',
          label: 'Internal Outlinks',
          thClass: 'text-right',
          sortable: this.sortable,
          active: false,
          group: 'links'
        },
        {
          key: 'broken_links',
          label: 'Broken Outlinks',
          thClass: 'text-right',
          sortable: this.sortable,
          active: false,
          group: 'links'
        },
        {
          key: 'nofollow_links',
          label: 'Nofollow Inlinks',
          thClass: 'text-right',
          sortable: this.sortable,
          active: false,
          group: 'links'
        },
        {
          key: 'inbound_anchor_count',
          label: 'Anchor Texts',
          thClass: 'text-right',
          sortable: this.sortable,
          active: false,
          group: 'links'
        }
      ]
      return fields
    },
    fieldGroups() {
      return [
        ['page', 'Page Info'],
        ['title', 'Title Opportunities'],
        ['links', 'Link Opportunities']
      ].map(([key, label]) => ({
        key,
        label,
        fields: this.activeFields.filter((f) => f.group == key)
      }))
    },
    filterGroups() {
      return [
        {
          text: 'Titles',
          filters: [
            {
              value: 'drafts',
              text: 'Drafts',
              disabled: !_.get(this, 'site.total_drafts.aggregate.count')
            },
            {
              value: 'title_opportunities',
              text: 'Low Scores Only',
              disabled: !_.get(this, 'site.total_opportunities.aggregate.count')
            },
            {
              value: 'optimized',
              text: 'Optimized',
              disabled: !_.get(this, 'site.total_approved.aggregate.count')
            },
            {
              value: 'notitle',
              text: 'Missing'
              // disabled: !_.get(this, 'site.total_approved.aggregate.count'),
            },
            {
              value: 'duplicates',
              text: 'Duplicates',
              disabled:
                _.get(this, 'site.total_uniques.aggregate.count') !=
                _.get(this, 'site.total_pages.aggregate.count')
            },
            {
              value: 'rewritten',
              text: 'Google Rewriting'
            }
          ]
        },
        {
          text: 'Internal Links',
          filters: [
            {
              value: 'link_opportunities',
              text: 'Low Scores Only'
              // disabled: !_.get(this, 'site.total_opportunities.aggregate.count'),
            },
            {
              value: 'nolinks',
              text: 'No Incoming'
            },
            {
              value: 'fewlinks',
              text: 'Few Incoming'
            },
            {
              value: 'improved',
              text: 'Optimized'
            },
            {
              value: 'nooutlinks',
              text: 'No Outgoing'
            },
            {
              value: 'brokenlinks',
              text: 'Broken Links'
            },
            {
              value: 'fewanchors',
              text: 'Low Anchor Divsersity'
            },
            {
              value: 'nofollowlinks',
              text: 'Incoming nofollow'
            }
          ]
        },
        {
          text: 'Status Code',
          filters: [
            {
              value: 'ok',
              text: '2xx Success'
            },
            {
              value: 'redirects',
              text: '3xx Redirects'
            },
            {
              value: 'notfound',
              text: '4xx Client Error'
            },
            {
              value: 'errors',
              text: '5xx Server Errors'
            }
          ]
        },
        {
          text: 'Optimization Status',
          filters: [
            {
              value: 'not_started',
              text: 'Not Started'
            },
            {
              value: 'in_progress',
              text: 'In Progress'
            },
            {
              value: 'completed',
              text: 'Monitoring'
            },
            {
              value: 'archived',
              text: 'Archived'
            },
            {
              value: 'ignored',
              text: 'Ignored'
            }
          ]
        },
        {
          text: 'Other',
          filters: [
            {
              value: 'perf_opportunities',
              text: 'Page Speed Opportunities'
            }
          ]
        }
      ]
    },
    items() {
      return _.uniqBy(this.pages, (e) => e.id).map((e) => {
        e._rowVariant =
          e.id == this.$route.params.page_id
            ? 'selected'
            : e.id == this.hoveredPageId
            ? 'hovered'
            : ''
        return e
      })
    },
    activeFilter() {
      for (const group of this.filterGroups) {
        const filter = group.filters.find((e) => e.value == this.type)
        if (filter) {
          filter.group = group.text
          return filter
        }
      }
      return {}
    },
    obscuredTooltip() {
      return {
        title: `Results are limited during the <a href="/account">free trial</a>`,
        html: true
      }
    },
    hasTitleField() {
      return this.activeFields.some((e) => e.key == 'title' && e.active)
    }
  },
  watch: {
    pages: {
      immediate: true,
      handler() {
        if (this.pages.length && !this.hasDetailPane) {
          this.hoveredPageId = this.pages[0].id
        }
      }
    },
    type: {
      immediate: true,
      handler: function () {
        this.setDefaultFields()
      }
    },
    activeFields: {
      deep: true,
      handler(to) {
        this.saveFields(to)
      }
    }
  },
  methods: {
    titleCase: _.startCase,
    update(k, v) {
      this.$emit('input', { ...this.value, [k]: v })
    },
    liveTitle(page) {
      return page.published_at ? page.optimized_title : page.title
    },
    onRowHovered($event) {
      if ($event.isObscured) return
      this.hoveredPageId = $event.id
      this.$emit('row-hovered', $event)
    },
    onRowClicked($event) {
      if ($event.isObscured) return
      this.$emit('row-clicked', $event)
    },
    setField(field) {
      const i = this.activeFields.findIndex((e) => e.key == field.key)
      this.$set(this.activeFields, i, {
        ...this.activeFields[i],
        active: !field.active
      })
      this.$emit('update:fields', this.activeFields)
    },
    setFilter(value) {
      if (value == this.type) {
        value = 'all'
      }
      this.$emit('update:type', value)
      _zyppy.track('Pages Filtered', {
        label: value
      })
    },
    setDefaultFields(reset = false) {
      const always = ['potential', 'url', 'clicks']
      if (this.value.sort) {
        always.push(this.value.sort)
      }
      const fallback = always.concat([
        'title_score',
        'link_score',
        'perf_score',
        'title'
      ])
      const defaultFields = {
        rewritten: ['serp_title'].concat(fallback),
        fewanchors: ['inbound_anchor_count'].concat(fallback),
        nofollowlinks: ['nofollow_links'].concat(fallback),
        brokenlinks: ['broken_links'].concat(fallback),
        notstarted: ['potential', 'status'].concat(fallback),
        inprogress: ['improved_at', 'status'].concat(fallback),
        completed: ['improved_at'].concat(
          always,
          this.fieldGroups.find((g) => g.key == 'page').fields.map((e) => e.key)
        ),
        archived: ['improved_at', 'status'].concat(fallback),
        ignored: ['potential', 'status'].concat(fallback),
        link_opportunities: always.concat(
          this.fieldGroups
            .find((g) => g.key == 'links')
            .fields.map((e) => e.key)
        ),
        title_opportunities: always.concat(
          this.fieldGroups
            .find((g) => g.key == 'title')
            .fields.map((e) => e.key)
            .filter((e) => e != 'serp_title')
        ),
        perf_opportunities: [
          'perf_score',
          'response_time',
          'asset_length',
          'status_code'
        ].concat(fallback)
      }
      // Reset to default
      if (reset && !defaultFields[this.type]) {
        defaultFields[this.type] = fallback
      }
      for (const [filter, fields] of Object.entries(defaultFields)) {
        if (this.type == filter && this.sortable) {
          for (const field of this.fields) {
            const active = fields.some((e) => e == field.key)
            if (field.active != active) {
              this.setField(field)
            }
          }
          this.update('sort', fields[0])
          break
        }
      }
    },
    setSearch($event) {
      this.$emit('update:q', $event)
      _zyppy.track('Pages Searched', {
        label: $event
      })
    },
    fetchFields() {
      return JSON.parse(localStorage.getItem('pages_fields')) || []
    },
    saveFields(data) {
      localStorage.setItem('pages_fields', JSON.stringify(data))
    },
    async toggleFields({ key }) {
      const active = !this.activeFields
        .filter((f) => f.group == key)
        .every((f) => f.active)
      this.activeFields.forEach((f, i) => {
        if (f.group == key && f.active != active) {
          this.setField(i, active)
        }
      })
    },
    // Used by Opportunities.vue and Pages.vue
    isObscured(page, isFreetrial) {
      return false
      if (!isFreetrial || page.approved_at) return false
      const createdAt = new Date(page.created_at).getTime()
      return createdAt % 4 == 0
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.isObscured) {
        return 'disabled'
      }
    }
  }
}
</script>